/**
 * 版本号 - 从 package.json 读取
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "1.0.0";
console.log('APP_VERSION', APP_VERSION);

/**
 * APP KEY
*/
export const APP_KEY = 'mtunion_h5';

/**
 * 代码环境区分
*/
export enum CODE_ENV {
  DEVELOP = 'development',
  TEST = 'test',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

/**
 * 当前执行环境
*/
export const CURRENT_CODE_ENV = (process.env.NODE_ENV || CODE_ENV.PRODUCTION) as CODE_ENV;

/**
 * 系统平台枚举
 */
export enum SYSTEM_PLATFORM {
  IOS = "IOS",
  ANDROID = "Android",
  HARMONY_OS = "HarmonyOS",
  UNKNOWN = "Unknown",
}

/**
 * 运行容器枚举，接口入参 platform 使用
 */
export enum CONTAINER_PLATFORM_TYPE {
  BROWSER = 2,
  MT_MINI = 3,
  MT_APP = 6,
}

/**
 * 运行容器枚举
 */
export enum RUNTIME_ENV_TYPE {
  MT_MINI = "mt_mini", // 美团小程序（美小）
  MT_APP = "mt_app", // 美团App
  WX_BROWSER = "wx_browser", // 微信浏览器
  BROWSER = "browser", // 其他浏览器
  UNKNOWN = "unknown",
}

export enum LX_ENV_TYPE {
  MT_MINI = "tmini",
  MT_APP = "tapp",
  WX_BROWSER = "wxh5",
  BROWSER = "h5",
  WAIMAI_APP = "wapp",
  WAIMAI_MINI = "wmini",
  HUISHENG_MINI = "hmini",
  UNKNOWN = "other",
}

export enum C_TYPE_ENUM {
  MT_APP_IOS = "mtiphone",
  MT_APP_ANDROID = "mtandroid",
  MT_APP_HARMONY_OS = "mt_wxharmony",
  MT_MINI = "mt_mp",
  H5 = "mti",
  WX_H5 = "wx_wallet",
}

export enum FP_PLATFORM_ENUM {
  WX = 11, // 微信浏览器或者微信小程序
  HM_APP = 60, // 鸿蒙APP
  ANDROID_APP = 4, // Android APP
  IOS_APP = 5, // iOS APP
  BROWSER = 3, // 浏览器
}

/**
 * 小程序 APP_ID 配置
 */
export const MT_APP_ID = "wxde8ac0a21135c07d"; // 美团小程序
export const WM_APP_ID = "wx2c348cf579062e56"; // 外卖小程序
export const HS_APP_ID = "wx0b42a347aafbe0d0"; // 惠省小程序
// export const MSC_APP_ID = "3624e0d16e0f4c8a"; // MSC

/**
 * H5 APP_ID 映射
 */
export const H5_APP_ID_MAP = {
  [MT_APP_ID]: "mtwx", // 美团小程序
  //   [WM_APP_ID]: "wmwx", // 外卖小程序
  [HS_APP_ID]: "hswx", // 惠省小程序
};

export const isServer = typeof window === 'undefined';
export const LX_CHANNEL = "waimai";

export const IP_LOCATE_KEY_MAP: Record<CODE_ENV, string> = {
  [CODE_ENV.DEVELOP]: "m1a9b929f2bb452a9d914345ab3aa37w",
  [CODE_ENV.TEST]: 'm1a9b929f2bb452a9d914345ab3aa37w',
  [CODE_ENV.STAGING]: 'm985fb0a7f944c58b523947974e84fbw',
  [CODE_ENV.PRODUCTION]: 'm0d23a282eb74d3fa3467efc30fd2c3w',
}
export const IP_LOCATE_KEY = IP_LOCATE_KEY_MAP[CURRENT_CODE_ENV || CODE_ENV.PRODUCTION];

/** 是否启用 SSR 经纬度优先定位（有 lat/lng 时走 divisionopencity，失败用兜底不回退 IP） */
export const ENABLE_SSR_COORD_LOCATE = true;

/**
 * 按环境区分的请求超时配置（单位：ms）
 */
export const TIMEOUT_CONFIG = {
  [CODE_ENV.DEVELOP]: 15000,
  [CODE_ENV.TEST]: 15000,
  [CODE_ENV.STAGING]: 5000,
  [CODE_ENV.PRODUCTION]: 5000,
};

/** 当前环境的 CSR 请求超时 */
export const TIMEOUT = TIMEOUT_CONFIG[CURRENT_CODE_ENV] ?? 5000;
